import { render, staticRenderFns } from "./SelectClient.vue?vue&type=template&id=773c2a88&"
import script from "./SelectClient.vue?vue&type=script&lang=js&"
export * from "./SelectClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports